import React from 'react';
import {Button} from "@mui/material";
import { useKeycloak } from "@react-keycloak/web";
import LoginIcon from '@mui/icons-material/Login';

const NavbarMenuButtonLogin = () => {
	const { keycloak, initialized } = useKeycloak();
	
	if (!initialized || (initialized && keycloak.authenticated)) {
		return <></>;
	}

	return (
		<Button color="inherit" sx={{mr: 0}} onClick={() => keycloak.login()}>
			<LoginIcon/>
		</Button>
	);
};

export default NavbarMenuButtonLogin;
